import { atom } from "jotai";
import { DoctorMSMedicalRecordEntity } from "lib/graphql/megaSchema";

export const selectedMedicalRecordsAtom = atom<DoctorMSMedicalRecordEntity[]>(
  [],
);
